// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
  min-height: 100vh;
  background: white;
  --pixory-ink: #211c24;
  --pixory-cream: #faf6f1;
  --pixory-pink: #e8a0b4;
  --pixory-pink-deep: #c96f8c;
  --pixory-muted: #7a7580;
}
body {
  font-family: "Gilroy", sans-serif;
}
.trust-icon {
  font-size: 28px;
  color: #2d2d2d; /* ose brand color */
}

/* Mobile Categories Bar - Initially hidden, shown on mobile */
.mobile-categories-bar {
  display: none;
  background: white;
  border-bottom: 1px solid #e2e8f0;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding: 12px 20px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  position: sticky;
  top: 97px; /* Adjust based on header height */
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.mobile-categories-bar::-webkit-scrollbar {
  display: none; /* Chrome, Safari */
}

.mobile-category-btn {
  display: inline-block;
  padding: 10px 20px;
  margin-right: 10px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #4a5568;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  font-family: "Gilroy", sans-serif;
}

.mobile-category-btn:hover {
  background: #f7fafc;
  border-color: #cbd5e0;
}

.mobile-category-btn.active {
  background: darkgray;
  color: white;
  border-color: darkgray;
}

.mobile-category-btn:last-child {
  margin-right: 0;
}

/* ── New Hero Section ── */
.hero-new-section {
  padding: 28px 50px 18px;
}

.hero-new-inner {
  display: grid;
  grid-template-columns: 280px 1fr;
  align-items: center;
  gap: 48px;
}

.hero-new-text {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a202c;
  line-height: 1.45;
}

.hero-new-text p {
  margin: 0;
}

.hero-new-text strong {
  font-weight: 900;
}

.dest-scroll-wrapper {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.dest-scroll {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  flex: 1 1;
  min-width: 0;
}

.dest-scroll::-webkit-scrollbar {
  display: none;
}

.dest-card {
  flex-shrink: 0;
  width: 155px;
  height: 195px;
  border-radius: 18px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
}

.dest-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.35s ease;
  display: block;
}

.dest-card:hover img {
  transform: scale(1.06);
}

.dest-card::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.55) 0%, transparent 55%);
  border-radius: 18px;
}

.dest-label {
  position: absolute;
  bottom: 14px;
  left: 0;
  right: 0;
  text-align: center;
  color: white;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 2.5px;
  z-index: 1;
  text-shadow: 0 1px 3px rgba(0,0,0,0.3);
}

.dest-arrow-btn {
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: white;
  border: 1px solid #e2e8f0;
  font-size: 1.6rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  transition: box-shadow 0.2s, transform 0.2s;
  color: #2d3748;
}

.dest-arrow-btn:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.13);
  transform: scale(1.05);
}

/* ── New Offer Card ── */
.offer-card-section {
  padding: 8px 50px 28px;
}

.offer-card-new {
  background: #f2f2f2;
  border-radius: 22px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  padding: 44px 52px 44px 56px;
  gap: 24px;
  overflow: hidden;
  position: relative;
}

.offer-card-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.offer-chip {
  display: inline-block;
  background: #e0e0e0;
  color: #333;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 5px 14px;
  border-radius: 20px;
  letter-spacing: 0.6px;
  margin-bottom: 18px;
  font-family: "Gilroy", sans-serif;
}

.offer-card-title {
  font-size: 2.6rem;
  font-weight: 900;
  color: #1a202c;
  margin: 0 0 14px;
  line-height: 1.1;
  font-family: "Gilroy", sans-serif;
}

.offer-card-desc {
  font-size: 0.95rem;
  color: #718096;
  margin: 0 0 30px;
  line-height: 1.55;
  font-family: "Gilroy", sans-serif;
}

.offer-card-btn-new {
  display: inline-block;
  background: #1a202c;
  color: white;
  padding: 14px 34px;
  border-radius: 50px;
  font-weight: 700;
  font-size: 0.95rem;
  text-decoration: none;
  transition: background 0.2s;
  font-family: "Gilroy", sans-serif;
}

.offer-card-btn-new:hover {
  background: #2d3748;
}

.offer-card-visual {
  position: relative;
  flex-shrink: 0;
}

.offer-books-img {
  width: 300px;
  height: auto;
  display: block;
  object-fit: contain;
}


@media (max-width: 1280px) {
  .hero-new-section {
    padding: 24px 40px 16px;
  }
  .offer-card-section {
    padding: 8px 40px 24px;
  }
  .hero-new-inner {
    grid-template-columns: 240px 1fr;
    gap: 36px;
  }
}

@media (max-width: 1024px) {
  .hero-new-section {
    padding: 20px 30px 14px;
  }
  .offer-card-section {
    padding: 6px 30px 20px;
  }
  .hero-new-inner {
    grid-template-columns: 200px 1fr;
    gap: 28px;
  }
  .hero-new-text {
    font-size: 1.2rem;
  }
  .offer-card-title {
    font-size: 2rem;
  }
  .offer-books-img {
    width: 240px;
  }
  .dest-card {
    width: 140px;
    height: 178px;
  }
}

@media (max-width: 768px) {
  .hero-new-section {
    padding: 16px 20px 12px;
  }
  .offer-card-section {
    padding: 4px 20px 16px;
  }
  .hero-new-inner {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .hero-new-text {
    font-size: 1.15rem;
    text-align: left;
  }
  .dest-card {
    width: 130px;
    height: 164px;
  }
  .dest-arrow-btn {
    display: none;
  }
  .offer-card-new {
    padding: 26px 20px 26px 24px;
    grid-template-columns: 1fr 120px;
    gap: 10px;
    align-items: center;
  }
  .offer-card-title {
    font-size: 1.5rem;
    margin-bottom: 10px;
  }
  .offer-chip {
    margin-bottom: 12px;
  }
  .offer-card-desc {
    font-size: 0.85rem;
    margin-bottom: 20px;
  }
  .offer-card-btn-new {
    padding: 11px 22px;
    font-size: 0.85rem;
  }
  .offer-books-img {
    width: 120px;
  }
}

/* Hero Slider Section */
.hero-slider-section {
  position: relative;
  overflow: hidden;
  max-width: 1325px;
  margin: 20px auto;
  border-radius: 15px;
  min-height: 450px;
}

.hero-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0;
  transition: opacity 2s ease-in-out;
  z-index: 1;
}

.hero-slide.active {
  opacity: 1;
  z-index: 2;
}

.hero-container {
  position: relative;
  z-index: 3;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 50px;
}

.hero-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  min-height: 450px;
}

.hero-text {
  animation: fadeInLeft 0.8s ease;
}

.hero-title {
  font-size: 2.8rem;
  font-weight: 900;
  margin: 0 0 20px 0;
  color: #2d3748;
  line-height: 1.2;
}

.hero-description {
  font-size: 1rem;
  color: #4a5568;
  line-height: 1.6;
  margin: 0 0 20px 0;
}

.hero-price {
  font-size: 1.3rem;
  font-weight: 700;
  color: darkcyan;
  margin: 20px 0;
}

.hero-btn {
  background: linear-gradient(135deg, darkcyan 0%, #ffb347 100%);
  color: white;
  border: none;
  padding: 14px 35px;
  font-size: 0.95rem;
  font-weight: 700;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 12px rgba(255, 140, 0, 0.3);
}

.hero-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(255, 140, 0, 0.4);
}

.hero-images {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 15px;
  animation: fadeInRight 0.8s ease;
  padding: 20px;
}

.hero-book {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  background: white;
}

.hero-book:hover {
  transform: translateY(-8px) scale(1.03);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
}

.hero-book img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.hero-book-1 {
  width: 160px;
  height: 220px;
}

.hero-book-2 {
  width: 180px;
  height: 250px;
  margin-bottom: 20px;
}

.hero-book-3 {
  width: 140px;
  height: 200px;
}

.book-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3.5rem;
  background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);
}



@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Old Hero Section - keeping for reference */
.hero-section {
  background: linear-gradient(135deg, #00beff 0%, #ff9c47 100%);
  padding: 80px 50px;
  position: relative;
  overflow: hidden;
  min-height: 500px;
  display: none;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  pointer-events: none;
}

.hero-content {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  position: relative;
  z-index: 1;
}

.hero-text {
  color: white;
  animation: fadeInLeft 1s ease;
}

.hero-title {
  font-size: 4rem;
  font-weight: 900;
  margin: 0 0 15px 0;
  letter-spacing: 2px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 25px 0;
  opacity: 0.95;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.hero-description {
  font-size: 1.1rem;
  line-height: 1.8;
  margin: 0 0 35px 0;
  opacity: 0.9;
  max-width: 550px;
}

.hero-btn {
  background: white;
  color: #ed2b91;
  border: none;
  padding: 15px 40px;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  letter-spacing: 1px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.hero-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  background: #2d3748;
  color: white;
}

/* Hero Books Display */
.hero-books {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: flex-end;
  animation: fadeInRight 1s ease;
}

.book-display {
  transition: transform 0.3s ease;
  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.3));
}

.book-display:hover {
  transform: translateY(-10px) scale(1.05);
}

.book-1 {
  width: 180px;
  height: 250px;
}

.book-2 {
  width: 200px;
  height: 280px;
}

.book-3 {
  width: 170px;
  height: 240px;
}

.book-cover {
  width: 100%;
  height: 100%;
  background-image: url(https://www.foleja.com/cdn-cgi/image/fit=scale-down,format=auto,height=1600,width=1600/media/87/84/2e/1700572228/nje-shqiptar-ne-cia-autori-bashmir-xhemaj--duk-200000059-0.webp);
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  box-shadow: 
    inset -3px 0 8px rgba(0, 0, 0, 0.1),
    inset 3px 0 8px rgba(255, 255, 255, 0.3);
}

.book-cover::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 8px;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.1), transparent);
  border-radius: 8px 0 0 8px;
}

.book-cover-blue {
  background-image: url(https://www.foleja.com/cdn-cgi/image/fit=scale-down,format=auto,height=1600,width=1600/media/d6/72/06/1725219914/the-body-keeps-the-score-autori-bessel-van-der-kolk-duk-200000123-0.webp);
  background-size: cover;
  background-position: center;
}

.book-cover-pink {
  background-image: url(https://www.foleja.com/cdn-cgi/image/fit=scale-down,format=auto,height=1600,width=1600/media/f9/96/41/1725219316/peter-camenzind-autori-herman-hesse-duk-200000033-0.webp);
  background-size: cover;
  background-position: center;
}

.book-title {
  font-size: 1.5rem;
  font-weight: 900;
  color: inherit;
  line-height: 1.3;
  text-transform: uppercase;
}

.book-cover-blue .book-title {
  color: white;
  font-size: 1.4rem;
}

.book-cover-pink .book-title-small {
  color: white;
  font-size: 1.3rem;
  font-weight: 900;
  line-height: 1.3;
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Features Trust Section */
.features-trust-section {
  background: #f8f9fa;
  padding: 40px 50px;
  border-bottom: 1px solid #e2e8f0;
}

.features-trust-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  max-width: 1400px;
  margin: 0 auto;
}

.trust-card {
  display: flex;
  align-items: center;
  gap: 15px;
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.trust-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.trust-icon {
  font-size: 2.5rem;
  flex-shrink: 0;
}

.trust-content h4 {
  font-size: 0.95rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 5px 0;
  font-family: "Gilroy", sans-serif;
}

.trust-content p {
  font-size: 0.85rem;
  color: #718096;
  margin: 0;
  font-family: "Gilroy", sans-serif;
}

/* Book Store Section */
.book-store-section {
  padding: 80px 50px;
  background: white;
}

.store-layout {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 40px;
  align-items: start;
}

/* Sidebar Categories */
.categories-sidebar {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  position: sticky;
  top: 20px;
  align-self: start;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-sidebar-btn {
  display: none;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #718096;
  padding: 5px;
  transition: all 0.3s ease;
}

.close-sidebar-btn:hover {
  color: #2d3748;
}

.sidebar-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.sidebar-title {
  font-size: 1.3rem;
  font-weight: 800;
  color: #2d3748;
  margin: 0 0 20px 0;
  padding-bottom: 15px;
  border-bottom: 2px solid #e2e8f0;
  font-family: "Gilroy", sans-serif;
}

.category-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.category-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: none;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Gilroy", sans-serif;
  font-size: 0.95rem;
  color: #4a5568;
  text-align: left;
  width: 100%;
}

.category-item:hover {
  background: #f7fafc;
  color: #2d3748;
}

.category-item.active {
  background: darkgray;
  color: white;
  font-weight: 700;
}

.category-icon {
  font-size: 1.5rem;
}

.category-name {
  flex: 1 1;
}

.category-arrow {
  font-size: 1.2rem;
  opacity: 0.5;
}

.category-item.active .category-arrow {
  opacity: 1;
}

/* Book Store Section */
.book-store-section {
  padding: 80px 50px;
  background: white;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

.store-title {
  font-size: 3rem;
  font-weight: 900;
  font-family: "Gilroy", sans-serif;
  text-align: center;
  color: #2d3748;
  margin: 0 0 15px 0;
  letter-spacing: 2px;
}

.store-subtitle {
  text-align: center;
  color: #718096;
  font-size: 1.1rem;
  margin: 0 0 60px 0;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
    font-family: "Gilroy", sans-serif;

}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.section-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.view-all-link {
  color: #666;
  text-decoration: underline;
  font-size: 0.95rem;
  transition: color 0.3s ease;
}

.view-all-link:hover {
  color: #333;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  animation: fadeIn 0.6s ease;
}

/* Info Cards Section */
.info-cards-section {
  padding: 60px 50px;
  background: white;
}

.info-cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.info-card {
  background: #2d3748;
  border-radius: 8px;
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 220px;
  transition: all 0.3s ease;
}

.info-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.info-card-content {
  padding: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}

.info-card-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: white;
  margin: 0;
  line-height: 1.3;
  text-transform: uppercase;
}

.info-card-subtitle {
  font-size: 0.95rem;
  color: white;
  margin: 0;
}

.payment-logos {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  margin-top: 10px;
}

.payment-logo {
  background: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  text-align: center;
  color: #333;
  border: 1px solid #e0e0e0;
}

.info-card-image {
  position: relative;
  overflow: hidden;
}

.info-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.info-card:hover .info-card-image img {
  transform: scale(1.05);
}

/* Promo Section */
.promo-section {
  padding: 60px 50px;
  background: white;
}

.promo-cards {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 20px;
  margin-bottom: 50px;
}

.promo-card {
  min-height: 450px;
  border-radius: 12px;
  overflow: hidden;
}

.promo-image-card {
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.promo-image-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.promo-content-card {
  background: #2d3748;
  padding: 60px 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
}

.promo-badge {
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 2px;
  margin-bottom: 20px;
  opacity: 0.9;
}

.promo-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 20px 0;
  line-height: 1.2;
}

.promo-description {
  font-size: 1.1rem;
  margin: 0 0 30px 0;
  opacity: 0.95;
}

.promo-btn {
  background: white;
  color: #2d3748;
  border: none;
  padding: 16px 40px;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
}

.promo-btn:hover {
  background: #1a202c;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

/* Features Row */
.features-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-item {
  text-align: center;
  padding: 20px;
}

.feature-icon {
  font-size: 3rem;
  margin-bottom: 15px;
  color: #333;
}

.feature-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #333;
  margin: 0 0 10px 0;
}

.feature-text {
  font-size: 0.95rem;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Footer */
.footer {
  background: #2d3748;
  color: white;
  padding: 40px 50px;
  margin-top: 0;
}

.footer-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-content p {
  margin: 0;
  font-size: 0.95rem;
}

.footer-links {
  display: flex;
  gap: 30px;
}

.footer-links a {
  color: white;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: inherit;
}

/* Responsive Design */
@media (max-width: 1400px) {
  .products-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 1024px) {
  .hero-container {
    padding: 0 30px;
  }

  .hero-content {
    gap: 40px;
  }

  .hero-title {
    font-size: 2.3rem;
  }

  .hero-book-1 {
    width: 130px;
    height: 180px;
  }

  .hero-book-2 {
    width: 150px;
    height: 210px;
  }

  .hero-book-3 {
    width: 110px;
    height: 160px;
  }
  
  .book-store-section {
    padding: 50px 30px;
  }

  .store-layout {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .categories-sidebar {
    position: static;
  }

  .category-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .features-trust-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  
  .products-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
  }

  .info-cards-section {
    padding: 50px 30px;
  }

  .info-cards-grid {
    gap: 15px;
  }

  .promo-section {
    padding: 50px 30px;
  }

  .promo-title {
    font-size: 2rem;
  }

  .features-row {
    gap: 30px;
  }
}

@media (max-width: 768px) {
  .hero-slider-section {
   /* padding: 20px 10px; */
    padding: 75px 10px;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    min-height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
  }

  .hero-container {
    padding: 0;
    width: 100%;
  }

  .hero-content {
    grid-template-columns: 1fr;
    gap: 20px;
    min-height: auto;
  }

  .hero-text {
    text-align: center;
    display: none;
  }

  .hero-title {
    font-size: 1.8rem;
  }

  .hero-description {
    font-size: 0.95rem;
  }

  .hero-price {
    font-size: 1.1rem;
  }

  .hero-images {
    justify-content: flex-end;
    padding: 10px 10px 10px 0;
    gap: 4px;
    margin-right: -10px;
  }

  .hero-book-1 {
    width: 55px;
    height: 75px;
  }

  .hero-book-2 {
    width: 70px;
    height: 95px;
    margin-bottom: 5px;
  }

  .hero-book-3 {
    width: 50px;
    height: 70px;
  }


  
  .hero-books {
    justify-content: center;
    gap: 15px;
  }
  
  .book-1,
  .book-2,
  .book-3 {
    width: 100px;
    height: 140px;
  }
  
  .book-2 {
    width: 110px;
    height: 155px;
  }
  
  .book-title,
  .book-cover-blue .book-title,
  .book-title-small {
    font-size: 0.8rem;
  }

  .book-store-section {
    padding: 40px 20px;
  }

  .store-layout {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  /* Show mobile categories bar */
  .mobile-categories-bar {
    display: block;
  }

  /* Hide sidebar completely on mobile */
  .categories-sidebar {
    display: none;
  }

  /* Hide sidebar overlay on mobile */
  .sidebar-overlay {
    display: none;
  }

  .features-trust-section {
    padding: 30px 20px;
  }

  .features-trust-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .trust-card {
    padding: 15px;
  }

  .store-title {
    font-size: 2rem;
  }

  .store-subtitle {
    font-size: 1rem;
    margin-bottom: 40px;
  }

  .section-title {
    font-size: 1.5rem;
  }

  .products-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .info-cards-section {
    padding: 40px 20px;
  }

  .info-cards-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .info-card {
    grid-template-columns: 1fr;
    min-height: auto;
  }

  .info-card-image {
    height: 180px;
  }

  .promo-section {
    padding: 40px 20px;
  }

  .promo-cards {
    grid-template-columns: 1fr;
    margin-bottom: 40px;
  }

  .promo-card {
    min-height: 300px;
  }

  .promo-content-card {
    padding: 40px 25px;
  }

  .promo-title {
    font-size: 1.8rem;
  }

  .promo-description {
    font-size: 1rem;
  }

  .features-row {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .feature-icon {
    font-size: 2.5rem;
  }
  
  .footer {
    padding: 30px 20px;
  }
  
  .footer-content {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
  
  .footer-links {
    gap: 20px;
  }
}

/* ==========================================================================
   Figma design port - Hero, category banners, steps, curated product rows
   ========================================================================== */

/* Hero — Pixory-style washed flat-lay: Fletaime's own covers scattered
   behind a white wash, centered white copy + white pill CTA on top. */
.pixory-hero {
  position: relative;
  margin: 16px 24px 0;
  border-radius: 18px;
  min-height: 520px;
  background: #f6f3ef;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pixory-hero-photo {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* White wash over the collage, below the content */
.pixory-hero::after {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.55);
}

.pixory-hero-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 18px;
  padding: 72px 24px;
}

.pixory-hero-title {
  font-size: clamp(34px, 4.5vw, 54px);
  font-weight: 700;
  color: white;
  line-height: 1.15;
  margin: 0;
  text-transform: lowercase;
  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.22);
}

.pixory-hero-subtitle {
  color: white;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  max-width: 480px;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.35), 0 2px 16px rgba(0, 0, 0, 0.25);
}

.pixory-hero-btn {
  border: none;
  background: white;
  color: #5a5a5a;
  padding: 15px 44px;
  border-radius: 999px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.pixory-hero-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
}

/* Category banners */
.figma-banners {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.figma-banners-left {
  flex: 1 1 400px;
  display: flex;
  flex-direction: column;
}

.figma-banner-wide {
  background: white;
  height: 328px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.figma-banner-wide-img-wrap {
  flex: 0 0 40%;
  height: 100%;
  overflow: hidden;
}

.figma-banner-wide-img-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.figma-banner-wide-text {
  flex: 1 1;
  min-width: 0;
  text-align: right;
  padding: 0 48px;
}

.figma-banner-wide-title {
  font-size: 40px;
  color: #000;
  margin: 0 0 12px;
  font-weight: 800;
  letter-spacing: 1px;
}

.figma-banner-wide-desc {
  font-size: 14px;
  color: #909090;
  line-height: 1.6;
  margin: 0;
}

.figma-banners-squares {
  display: flex;
  height: 272px;
}

.figma-banner-square {
  flex: 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.figma-banner-square.light { background: var(--pixory-cream); }
.figma-banner-square.dark { background: var(--pixory-ink); }

.figma-banner-square-img-wrap {
  flex: 0 0 42%;
  height: 100%;
  overflow: hidden;
}

.figma-banner-square-img-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.figma-banner-square-img-wrap img.mirrored {
  transform: scaleX(-1);
}

.figma-banner-square-text {
  flex: 1 1;
  min-width: 0;
  text-align: right;
  padding: 0 20px;
}

.figma-banner-square-title {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1.3;
  margin: 0 0 8px;
  color: #000;
}

.figma-banner-square-title span {
  font-weight: 800;
  color: var(--pixory-pink-deep);
}

.figma-banner-square.dark .figma-banner-square-title {
  color: #fff;
}

.figma-banner-square-desc {
  font-size: 13px;
  color: #909090;
  margin: 0;
}

.figma-banner-big {
  flex: 1 1 300px;
  height: 600px;
  background: #e2e2e2;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.figma-banner-big-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Cilësia e produktit */
.figma-features {
  display: flex;
  gap: 24px;
  padding: 56px 80px;
  background: white;
  flex-wrap: wrap;
}

/* Pixory-style feature card: gray head (title + desc) over a large photo */
.figma-feature-card {
  flex: 1 1 280px;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
}

.figma-feature-head {
  background: #f5f5f5;
  padding: 20px 24px 24px;
  min-height: 130px;
}

.figma-feature-title {
  font-size: 20px;
  font-weight: 700;
  color: #b3b3b3;
  text-transform: lowercase;
  margin: 0 0 10px;
}

.figma-feature-desc {
  font-size: 14px;
  color: #3a3a3a;
  line-height: 1.5;
  margin: 0;
}

.figma-feature-photo {
  aspect-ratio: 1 / 1;
  overflow: hidden;
}

.figma-feature-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Njihu me markën — foto majtas, titull + accordion djathtas */
.figma-brand-section {
  display: flex;
  margin: 0 80px 56px;
  border-radius: 12px;
  overflow: hidden;
  min-height: 560px;
}

.figma-brand-photo {
  flex: 1 1 50%;
  min-width: 0;
}

.figma-brand-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.figma-brand-content {
  flex: 1 1 50%;
  background: #f5f5f5;
  padding: 40px 48px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 24px;
}

.figma-brand-title {
  font-size: 30px;
  font-weight: 700;
  color: #c4c4c4;
  text-transform: lowercase;
  margin: 0 0 6px;
}

.figma-brand-sub {
  font-size: 15px;
  color: #3a3a3a;
  margin: 0;
}

.figma-brand-item {
  border-top: 1px solid #e8e8e8;
}

.figma-brand-item:first-child {
  border-top: none;
}

.figma-brand-item-head {
  width: 100%;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 0;
  font-family: inherit;
  font-size: 20px;
  font-weight: 700;
  color: #2d2d2d;
  text-transform: lowercase;
  text-align: left;
}

.figma-brand-chevron {
  width: 18px;
  height: 18px;
  color: #b3b3b3;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.figma-brand-chevron.open {
  transform: rotate(180deg);
}

.figma-brand-item-text {
  font-size: 15px;
  color: #3a3a3a;
  line-height: 1.5;
  margin: 0 0 16px;
  max-width: 440px;
}

/* Si funksionon steps */
.figma-steps {
  background: #fafafa;
  padding: 56px 80px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.figma-steps-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.figma-steps-title {
  font-size: 24px;
  font-weight: 500;
  color: #2e2e2e;
  margin: 0;
}

.figma-steps-arrows {
  display: flex;
  gap: 16px;
}

.figma-steps-arrow {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
}

.figma-steps-arrow img {
  width: 32px;
  height: 32px;
}

.figma-steps-arrow.rotated img {
  transform: rotate(180deg);
}

.figma-steps-row {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.figma-step-card {
  background: #e2e2e2;
  border-radius: 15px;
  flex: 1 1 140px;
  min-width: 135px;
  height: 128px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
}

.figma-step-icon {
  width: 40px;
  height: 40px;
  color: #2e2e2e;
}

.figma-step-label {
  font-size: 16px;
  font-weight: 500;
  color: #2e2e2e;
  text-align: center;
  margin: 0;
}

/* Curated product sections — Pixory-style white row cards on light gray */
.figma-products-section,
.figma-discounts-section {
  padding: 32px 40px 40px;
  background: #f4f4f4;
}

.figma-category-row {
  background: white;
  border: 1px solid #ececec;
  border-radius: 14px;
  padding: 20px 20px 24px;
  margin-bottom: 20px;
}

.figma-category-row:last-child {
  margin-bottom: 0;
}

/* Loading placeholder for the category rows — occupies roughly the same
   space as the real content so nothing below (e.g. "njihu me markën")
   jumps around once products finish loading in. */
.skeleton-block {
  background: linear-gradient(90deg, #eee 25%, #f5f5f5 37%, #eee 63%);
  background-size: 400% 100%;
  animation: skeleton-pulse 1.4s ease infinite;
  border-radius: 8px;
}

.skeleton-row-title {
  width: 140px;
  height: 20px;
}

.skeleton-card {
  aspect-ratio: 3 / 4;
  border-radius: 10px;
}

@keyframes skeleton-pulse {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}

.figma-category-row-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.figma-category-row-title {
  font-size: 18px;
  font-weight: 700;
  color: #a9a9a9;
  text-transform: lowercase;
  margin: 0;
}

.pixory-row-arrows {
  display: flex;
  gap: 10px;
}

.pixory-row-arrows button {
  background: none;
  border: 1px solid #e5e5e5;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: border-color 0.15s ease;
}

.pixory-row-arrows button:hover {
  border-color: #bdbdbd;
}

.pixory-row-arrows img {
  width: 16px;
  height: 16px;
  opacity: 0.6;
}

.pixory-row-arrows .rotated img {
  transform: rotate(180deg);
}

.figma-row-see-all {
  display: block;
  width: fit-content;
  margin: 20px auto 0;
  font-size: 15px;
  font-weight: 500;
  color: #2e2e2e;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: border-color 0.15s ease;
}

.figma-row-see-all:hover {
  border-bottom-color: #2e2e2e;
}

/* Pixory-style product card — Home.js only (PixoryHomeProductCard), not used
   by the Photobooks catalog, which keeps FigmaProductCard/.figma-product-card.
   Structure: gray lowercase series label + "e re" pill header, large centered
   cover, name/price row, dark pill CTA. */
/* 3 large cards visible per row; the rest scroll horizontally (snap + arrows) */
.pixory-card-grid {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: calc((100% - 40px) / 3);
  gap: 20px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  padding-bottom: 4px;
}

.pixory-card-grid::-webkit-scrollbar {
  display: none;
}

.pixory-card {
  background: white;
  border: 1px solid #ececec;
  border-radius: 16px;
  padding: 24px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  scroll-snap-align: start;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.pixory-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 26px rgba(0, 0, 0, 0.08);
}

.pixory-card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.pixory-card-label {
  flex: 1 1;
  font-size: 22px;
  font-weight: 700;
  color: #c4c4c4;
  margin: 0;
  text-transform: lowercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pixory-card-tag {
  background: #f8dee4;
  color: #3a3a3a;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 999px;
  flex-shrink: 0;
}

.pixory-card-like {
  background: white;
  border: 1px solid #eee;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  flex-shrink: 0;
}

.pixory-card-like.active {
  background: var(--pixory-pink-deep);
  border-color: var(--pixory-pink-deep);
}

.pixory-card-like.active img { filter: brightness(0) invert(1); }
.pixory-card-like img { width: 14px; height: 14px; }

/* No drop-shadow here: the mockup images carry white padding, so a shadow
   around the image rectangle reads as a white slab instead of a book. On the
   white card the padding blends away and the book "floats" like Pixory's. */
.pixory-card-image {
  position: relative;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.pixory-card-cover {
  max-width: 88%;
  max-height: 100%;
  object-fit: contain;
  transition: opacity 0.25s ease;
}

/* Second product photo, revealed on hover (only on cards that have one) */
.pixory-card-cover-alt {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
}

.pixory-card:hover .has-alt .pixory-card-cover-alt {
  opacity: 1;
}

.pixory-card:hover .has-alt .pixory-card-cover:not(.pixory-card-cover-alt) {
  opacity: 0;
}

.pixory-card-info {
  margin-top: auto;
}

.pixory-card-meta {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: baseline;
  gap: 4px 8px;
  margin-bottom: 10px;
}

.pixory-card-name {
  font-size: 21px;
  font-weight: 700;
  color: #b9b9b9;
  text-transform: lowercase;
  margin: 0;
}

.pixory-card-price {
  font-size: 22px;
  font-weight: 700;
  color: #2e2e2e;
  margin: 0;
  white-space: nowrap;
}

.pixory-card-desc {
  font-size: 15px;
  color: #3a3a3a;
  line-height: 1.4;
  margin: 6px 0 0;
}

.pixory-card-btn {
  align-self: flex-start;
  background: #3a3a3a;
  color: white;
  border: none;
  border-radius: 999px;
  padding: 14px 38px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 16px;
  transition: background 0.2s ease;
}

.pixory-card-btn:hover {
  background: #222;
}

.figma-discounts-title {
  font-size: 16px;
  font-weight: 700;
  color: #a9a9a9;
  text-transform: lowercase;
  margin: 0 0 16px;
}

.figma-products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}

.figma-product-card {
  background: #e2e2e2;
  border-radius: 9px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  border: 1px solid grey;
}

.figma-like-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 1;
  background: white;
  border: none;
  padding: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
}

.figma-like-btn.active {
  background: #ca247b;
}

.figma-like-btn.active .figma-like-icon {
  filter: brightness(0) invert(1);
}

.figma-like-icon {
  width: 18px;
  height: 18px;
}

.figma-product-image {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.figma-product-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.figma-product-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
  padding: 20px 16px 24px;
  box-sizing: border-box;
}

.figma-product-name {
  font-size: 16px;
  font-weight: 500;
  color: #000;
  margin: 0;
}

.figma-product-price {
  font-size: 24px;
  font-weight: 600;
  color: #000;
  margin: 0;
}

.figma-product-discount {
  color: #b3251e;
  font-size: 14px;
}

.figma-product-btn {
  background: #2e2e2e;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 32px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

/* 4-up banner strip */
.figma-strip {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.figma-strip-item {
  flex: 1 1 260px;
  min-height: 320px;
  display: flex;
  align-items: flex-end;
  padding: 32px;
  cursor: pointer;
}

.figma-strip-item.white { background: white; }
.figma-strip-item.gray { background: #e2e2e2; }
.figma-strip-item.dark { background: #2e2e2e; }

.figma-strip-title {
  font-size: 28px;
  font-weight: 300;
  color: #000;
  margin: 0 0 12px;
}

.figma-strip-title.dark { color: white; }

.figma-strip-desc {
  font-size: 14px;
  color: #909090;
  margin: 0 0 16px;
  max-width: 260px;
}

.figma-strip-desc.dark { color: #cfcfcf; }

.figma-strip-btn {
  border: 1px solid #2e2e2e;
  background: transparent;
  color: #2e2e2e;
  padding: 12px 32px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.figma-strip-btn.dark {
  border-color: white;
  color: white;
}

/* Testimonials and customer-photo gallery — styled ahead of time, rendered
   only once SHOW_TESTIMONIALS / SHOW_CUSTOMER_GALLERY are flipped on in
   Home.js with real content. */
.figma-testimonials-section,
.figma-gallery-section {
  padding: 56px 80px;
  background: #fafafa;
}

.figma-testimonials-title {
  font-size: 24px;
  font-weight: 500;
  color: #000;
  margin: 0 0 24px;
}

.figma-gallery-title {
  font-size: 30px;
  font-weight: 700;
  color: #c4c4c4;
  text-transform: lowercase;
  text-align: center;
  margin: 0 0 6px;
}

.figma-testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
}

.figma-testimonial-card {
  background: white;
  border: 1px solid #ece5e8;
  border-radius: 16px;
  padding: 24px;
}

.figma-testimonial-quote {
  font-size: 15px;
  color: #2e2e2e;
  line-height: 1.5;
  margin: 0 0 12px;
}

.figma-testimonial-author {
  font-size: 14px;
  font-weight: 600;
  color: #6b6b6b;
  margin: 0;
}

.figma-gallery-sub {
  font-size: 15px;
  color: #3a3a3a;
  text-align: center;
  margin: 0 0 32px;
}

.figma-gallery-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.figma-gallery-item {
  aspect-ratio: 3 / 4;
  border-radius: 8px;
  overflow: hidden;
}

.figma-gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.figma-gallery-social-btn {
  display: inline-block;
  margin-top: 24px;
  background: #d9d9d9;
  color: white;
  font-size: 15px;
  font-weight: 700;
  text-transform: lowercase;
  text-decoration: none;
  padding: 14px 32px;
  border-radius: 999px;
  transition: background 0.2s ease;
}

.figma-gallery-social-btn:hover {
  background: #c4c4c4;
}

/* Nevojë për ndihmë */
.figma-help-section {
  padding: 64px 80px;
  background: var(--pixory-cream);
  text-align: center;
}

.figma-help-title {
  font-size: 26px;
  font-weight: 700;
  color: var(--pixory-ink);
  margin: 0 0 8px;
}

.figma-help-desc {
  font-size: 15px;
  color: var(--pixory-muted);
  margin: 0 0 24px;
}

.figma-help-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.figma-help-btn {
  display: inline-block;
  padding: 14px 32px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  background: var(--pixory-ink);
  color: white;
  transition: transform 0.2s ease;
}

.figma-help-btn.outline {
  background: transparent;
  color: var(--pixory-ink);
  border: 1px solid var(--pixory-ink);
}

.figma-help-btn:hover {
  transform: translateY(-2px);
}

/* Phone only - iPad's 768px width and up keeps the banners. Placed after
   the base .figma-banners rule (line ~1599) since an earlier media query
   with equal specificity loses the cascade to a later unconditional rule. */
@media (max-width: 767px) {
  .figma-banners {
    display: none;
  }
}

@media (max-width: 900px) {
  .pixory-hero {
    margin: 12px 16px 0;
    border-radius: 14px;
    min-height: 420px;
  }

  .figma-steps,
  .figma-features,
  .figma-products-section,
  .figma-discounts-section,
  .figma-testimonials-section,
  .figma-gallery-section,
  .figma-help-section {
    padding: 32px 24px;
  }

  .figma-banner-wide {
    height: auto;
    flex-direction: column;
  }

  .figma-banner-wide-img-wrap {
    flex: 0 0 auto;
    width: 100%;
    height: 220px;
  }

  .figma-banner-wide-text {
    text-align: left;
    padding: 16px;
  }

  .figma-banners-squares {
    flex-direction: column;
    height: auto;
  }

  .figma-banner-square {
    flex-direction: column;
    height: auto;
  }

  .figma-banner-square-img-wrap {
    flex: 0 0 auto;
    width: 100%;
    height: 160px;
  }

  .figma-banner-square-text {
    text-align: left;
    padding: 16px;
    width: 100%;
  }

  .figma-banner-big {
    height: 320px;
  }

  .figma-products-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .pixory-card-grid {
    grid-auto-columns: 78%;
    gap: 14px;
  }

  .pixory-card {
    padding: 16px;
  }

  .pixory-card-image {
    height: 260px;
  }

  .pixory-card-label {
    font-size: 17px;
  }

  .pixory-card-name {
    font-size: 17px;
  }

  .pixory-card-price {
    font-size: 18px;
  }

  .pixory-card-desc {
    font-size: 14px;
  }

  .pixory-card-btn {
    padding: 12px 30px;
    font-size: 14px;
  }

  .figma-brand-section {
    flex-direction: column;
    margin: 0 16px 32px;
    min-height: 0;
  }

  .figma-brand-photo {
    flex: none;
    height: 260px;
  }

  .figma-brand-content {
    padding: 24px;
    gap: 28px;
  }

  .figma-brand-title {
    font-size: 24px;
  }

  .figma-brand-item-head {
    font-size: 17px;
  }

  .figma-gallery-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .figma-gallery-title {
    font-size: 24px;
  }

  .figma-product-info {
    padding: 12px 10px 16px;
    gap: 10px;
  }

  .figma-product-name {
    font-size: 14px;
  }

  .figma-product-price {
    font-size: 18px;
  }

  .figma-product-btn {
    padding: 10px 16px;
    font-size: 13px;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,cAAc,EAAE,oBAAoB;AACtC;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,qBAAqB,EAAE,YAAY;EACnC,gBAAgB;EAChB,SAAS,EAAE,kCAAkC;EAC7C,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,aAAa,EAAE,mBAAmB;AACpC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,yEAAyE;EACzE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;;AAGA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gCAAgC;IAChC,SAAS;EACX;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gCAAgC;IAChC,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,4BAA4B;IAC5B,gCAAgC;IAChC,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;AACF;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,UAAU;EACV,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,8DAA8D;EAC9D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;EACT,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6DAA6D;AAC/D;;;;AAIA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,6CAA6C;AAC7C;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;oFAEkF;EAClF,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,mBAAmB;EACnB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uMAAuM;EACvM,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB;;4CAE0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,sEAAsE;EACtE,0BAA0B;AAC5B;;AAEA;EACE,gNAAgN;EAChN,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,gMAAgM;EAChM,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,iCAAiC;AACnC;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,8BAA8B;EAC9B,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;IAChB,iCAAiC;;AAErC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;GACC,wBAAwB;IACvB,kBAAkB;IAClB,kCAAkC;IAClC,wBAAwB;IACxB,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;;;EAIA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;;;IAGE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA,+BAA+B;EAC/B;IACE,cAAc;EAChB;;EAEA,sCAAsC;EACtC;IACE,aAAa;EACf;;EAEA,mCAAmC;EACnC;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;;+EAE+E;;AAE/E;sEACsE;AACtE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,0EAA0E;AAC5E;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,6BAA6B,+BAA+B,EAAE;AAC9D,4BAA4B,6BAA6B,EAAE;;AAE3D;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,2EAA2E;AAC3E;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA,0EAA0E;AAC1E;;EAEE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;kDAEkD;AAClD;EACE,mEAAmE;EACnE,0BAA0B;EAC1B,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,KAAK,6BAA6B,EAAE;EACpC,OAAO,0BAA0B,EAAE;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;0CAG0C;AAC1C,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA,+BAA+B,+BAA+B,EAAE;AAChE,wBAAwB,WAAW,EAAE,YAAY,EAAE;;AAEnD;;4EAE4E;AAC5E;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,eAAe;AACjB;;AAEA,0BAA0B,iBAAiB,EAAE;AAC7C,yBAAyB,mBAAmB,EAAE;AAC9C,yBAAyB,mBAAmB,EAAE;;AAE9C;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA,0BAA0B,YAAY,EAAE;;AAExC;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,yBAAyB,cAAc,EAAE;;AAEzC;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;+BAE+B;AAC/B;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;4EAE4E;AAC5E;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;;;;;;;IAOE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;EACb;AACF","sourcesContent":[".home-page {\n  min-height: 100vh;\n  background: white;\n  --pixory-ink: #211c24;\n  --pixory-cream: #faf6f1;\n  --pixory-pink: #e8a0b4;\n  --pixory-pink-deep: #c96f8c;\n  --pixory-muted: #7a7580;\n}\nbody {\n  font-family: \"Gilroy\", sans-serif;\n}\n.trust-icon {\n  font-size: 28px;\n  color: #2d2d2d; /* ose brand color */\n}\n\n/* Mobile Categories Bar - Initially hidden, shown on mobile */\n.mobile-categories-bar {\n  display: none;\n  background: white;\n  border-bottom: 1px solid #e2e8f0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  white-space: nowrap;\n  padding: 12px 20px;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none; /* Firefox */\n  position: sticky;\n  top: 97px; /* Adjust based on header height */\n  z-index: 100;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.mobile-categories-bar::-webkit-scrollbar {\n  display: none; /* Chrome, Safari */\n}\n\n.mobile-category-btn {\n  display: inline-block;\n  padding: 10px 20px;\n  margin-right: 10px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #4a5568;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n  font-family: \"Gilroy\", sans-serif;\n}\n\n.mobile-category-btn:hover {\n  background: #f7fafc;\n  border-color: #cbd5e0;\n}\n\n.mobile-category-btn.active {\n  background: darkgray;\n  color: white;\n  border-color: darkgray;\n}\n\n.mobile-category-btn:last-child {\n  margin-right: 0;\n}\n\n/* ── New Hero Section ── */\n.hero-new-section {\n  padding: 28px 50px 18px;\n}\n\n.hero-new-inner {\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  align-items: center;\n  gap: 48px;\n}\n\n.hero-new-text {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #1a202c;\n  line-height: 1.45;\n}\n\n.hero-new-text p {\n  margin: 0;\n}\n\n.hero-new-text strong {\n  font-weight: 900;\n}\n\n.dest-scroll-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n}\n\n.dest-scroll {\n  display: flex;\n  gap: 12px;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  scrollbar-width: none;\n  flex: 1;\n  min-width: 0;\n}\n\n.dest-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.dest-card {\n  flex-shrink: 0;\n  width: 155px;\n  height: 195px;\n  border-radius: 18px;\n  overflow: hidden;\n  position: relative;\n  cursor: pointer;\n}\n\n.dest-card img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.35s ease;\n  display: block;\n}\n\n.dest-card:hover img {\n  transform: scale(1.06);\n}\n\n.dest-card::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to top, rgba(0,0,0,0.55) 0%, transparent 55%);\n  border-radius: 18px;\n}\n\n.dest-label {\n  position: absolute;\n  bottom: 14px;\n  left: 0;\n  right: 0;\n  text-align: center;\n  color: white;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 2.5px;\n  z-index: 1;\n  text-shadow: 0 1px 3px rgba(0,0,0,0.3);\n}\n\n.dest-arrow-btn {\n  flex-shrink: 0;\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background: white;\n  border: 1px solid #e2e8f0;\n  font-size: 1.6rem;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.08);\n  transition: box-shadow 0.2s, transform 0.2s;\n  color: #2d3748;\n}\n\n.dest-arrow-btn:hover {\n  box-shadow: 0 4px 16px rgba(0,0,0,0.13);\n  transform: scale(1.05);\n}\n\n/* ── New Offer Card ── */\n.offer-card-section {\n  padding: 8px 50px 28px;\n}\n\n.offer-card-new {\n  background: #f2f2f2;\n  border-radius: 22px;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  padding: 44px 52px 44px 56px;\n  gap: 24px;\n  overflow: hidden;\n  position: relative;\n}\n\n.offer-card-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.offer-chip {\n  display: inline-block;\n  background: #e0e0e0;\n  color: #333;\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 5px 14px;\n  border-radius: 20px;\n  letter-spacing: 0.6px;\n  margin-bottom: 18px;\n  font-family: \"Gilroy\", sans-serif;\n}\n\n.offer-card-title {\n  font-size: 2.6rem;\n  font-weight: 900;\n  color: #1a202c;\n  margin: 0 0 14px;\n  line-height: 1.1;\n  font-family: \"Gilroy\", sans-serif;\n}\n\n.offer-card-desc {\n  font-size: 0.95rem;\n  color: #718096;\n  margin: 0 0 30px;\n  line-height: 1.55;\n  font-family: \"Gilroy\", sans-serif;\n}\n\n.offer-card-btn-new {\n  display: inline-block;\n  background: #1a202c;\n  color: white;\n  padding: 14px 34px;\n  border-radius: 50px;\n  font-weight: 700;\n  font-size: 0.95rem;\n  text-decoration: none;\n  transition: background 0.2s;\n  font-family: \"Gilroy\", sans-serif;\n}\n\n.offer-card-btn-new:hover {\n  background: #2d3748;\n}\n\n.offer-card-visual {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.offer-books-img {\n  width: 300px;\n  height: auto;\n  display: block;\n  object-fit: contain;\n}\n\n\n@media (max-width: 1280px) {\n  .hero-new-section {\n    padding: 24px 40px 16px;\n  }\n  .offer-card-section {\n    padding: 8px 40px 24px;\n  }\n  .hero-new-inner {\n    grid-template-columns: 240px 1fr;\n    gap: 36px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .hero-new-section {\n    padding: 20px 30px 14px;\n  }\n  .offer-card-section {\n    padding: 6px 30px 20px;\n  }\n  .hero-new-inner {\n    grid-template-columns: 200px 1fr;\n    gap: 28px;\n  }\n  .hero-new-text {\n    font-size: 1.2rem;\n  }\n  .offer-card-title {\n    font-size: 2rem;\n  }\n  .offer-books-img {\n    width: 240px;\n  }\n  .dest-card {\n    width: 140px;\n    height: 178px;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero-new-section {\n    padding: 16px 20px 12px;\n  }\n  .offer-card-section {\n    padding: 4px 20px 16px;\n  }\n  .hero-new-inner {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  .hero-new-text {\n    font-size: 1.15rem;\n    text-align: left;\n  }\n  .dest-card {\n    width: 130px;\n    height: 164px;\n  }\n  .dest-arrow-btn {\n    display: none;\n  }\n  .offer-card-new {\n    padding: 26px 20px 26px 24px;\n    grid-template-columns: 1fr 120px;\n    gap: 10px;\n    align-items: center;\n  }\n  .offer-card-title {\n    font-size: 1.5rem;\n    margin-bottom: 10px;\n  }\n  .offer-chip {\n    margin-bottom: 12px;\n  }\n  .offer-card-desc {\n    font-size: 0.85rem;\n    margin-bottom: 20px;\n  }\n  .offer-card-btn-new {\n    padding: 11px 22px;\n    font-size: 0.85rem;\n  }\n  .offer-books-img {\n    width: 120px;\n  }\n}\n\n/* Hero Slider Section */\n.hero-slider-section {\n  position: relative;\n  overflow: hidden;\n  max-width: 1325px;\n  margin: 20px auto;\n  border-radius: 15px;\n  min-height: 450px;\n}\n\n.hero-slide {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  opacity: 0;\n  transition: opacity 2s ease-in-out;\n  z-index: 1;\n}\n\n.hero-slide.active {\n  opacity: 1;\n  z-index: 2;\n}\n\n.hero-container {\n  position: relative;\n  z-index: 3;\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 50px;\n}\n\n.hero-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 60px;\n  align-items: center;\n  min-height: 450px;\n}\n\n.hero-text {\n  animation: fadeInLeft 0.8s ease;\n}\n\n.hero-title {\n  font-size: 2.8rem;\n  font-weight: 900;\n  margin: 0 0 20px 0;\n  color: #2d3748;\n  line-height: 1.2;\n}\n\n.hero-description {\n  font-size: 1rem;\n  color: #4a5568;\n  line-height: 1.6;\n  margin: 0 0 20px 0;\n}\n\n.hero-price {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: darkcyan;\n  margin: 20px 0;\n}\n\n.hero-btn {\n  background: linear-gradient(135deg, darkcyan 0%, #ffb347 100%);\n  color: white;\n  border: none;\n  padding: 14px 35px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  box-shadow: 0 4px 12px rgba(255, 140, 0, 0.3);\n}\n\n.hero-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(255, 140, 0, 0.4);\n}\n\n.hero-images {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  gap: 15px;\n  animation: fadeInRight 0.8s ease;\n  padding: 20px;\n}\n\n.hero-book {\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n  transition: all 0.3s ease;\n  background: white;\n}\n\n.hero-book:hover {\n  transform: translateY(-8px) scale(1.03);\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);\n}\n\n.hero-book img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.hero-book-1 {\n  width: 160px;\n  height: 220px;\n}\n\n.hero-book-2 {\n  width: 180px;\n  height: 250px;\n  margin-bottom: 20px;\n}\n\n.hero-book-3 {\n  width: 140px;\n  height: 200px;\n}\n\n.book-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 3.5rem;\n  background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);\n}\n\n\n\n@keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes fadeInRight {\n  from {\n    opacity: 0;\n    transform: translateX(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Old Hero Section - keeping for reference */\n.hero-section {\n  background: linear-gradient(135deg, #00beff 0%, #ff9c47 100%);\n  padding: 80px 50px;\n  position: relative;\n  overflow: hidden;\n  min-height: 500px;\n  display: none;\n}\n\n.hero-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image: \n    radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n.hero-content {\n  max-width: 1400px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 60px;\n  align-items: center;\n  position: relative;\n  z-index: 1;\n}\n\n.hero-text {\n  color: white;\n  animation: fadeInLeft 1s ease;\n}\n\n.hero-title {\n  font-size: 4rem;\n  font-weight: 900;\n  margin: 0 0 15px 0;\n  letter-spacing: 2px;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);\n  line-height: 1.2;\n}\n\n.hero-subtitle {\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 25px 0;\n  opacity: 0.95;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.hero-description {\n  font-size: 1.1rem;\n  line-height: 1.8;\n  margin: 0 0 35px 0;\n  opacity: 0.9;\n  max-width: 550px;\n}\n\n.hero-btn {\n  background: white;\n  color: #ed2b91;\n  border: none;\n  padding: 15px 40px;\n  font-size: 1rem;\n  font-weight: 700;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  letter-spacing: 1px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.hero-btn:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n  background: #2d3748;\n  color: white;\n}\n\n/* Hero Books Display */\n.hero-books {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n  align-items: flex-end;\n  animation: fadeInRight 1s ease;\n}\n\n.book-display {\n  transition: transform 0.3s ease;\n  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.3));\n}\n\n.book-display:hover {\n  transform: translateY(-10px) scale(1.05);\n}\n\n.book-1 {\n  width: 180px;\n  height: 250px;\n}\n\n.book-2 {\n  width: 200px;\n  height: 280px;\n}\n\n.book-3 {\n  width: 170px;\n  height: 240px;\n}\n\n.book-cover {\n  width: 100%;\n  height: 100%;\n  background-image: url(https://www.foleja.com/cdn-cgi/image/fit=scale-down,format=auto,height=1600,width=1600/media/87/84/2e/1700572228/nje-shqiptar-ne-cia-autori-bashmir-xhemaj--duk-200000059-0.webp);\n  border-radius: 8px;\n  background-size: cover;\n  background-position: center;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  position: relative;\n  box-shadow: \n    inset -3px 0 8px rgba(0, 0, 0, 0.1),\n    inset 3px 0 8px rgba(255, 255, 255, 0.3);\n}\n\n.book-cover::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 8px;\n  background: linear-gradient(to right, rgba(0, 0, 0, 0.1), transparent);\n  border-radius: 8px 0 0 8px;\n}\n\n.book-cover-blue {\n  background-image: url(https://www.foleja.com/cdn-cgi/image/fit=scale-down,format=auto,height=1600,width=1600/media/d6/72/06/1725219914/the-body-keeps-the-score-autori-bessel-van-der-kolk-duk-200000123-0.webp);\n  background-size: cover;\n  background-position: center;\n}\n\n.book-cover-pink {\n  background-image: url(https://www.foleja.com/cdn-cgi/image/fit=scale-down,format=auto,height=1600,width=1600/media/f9/96/41/1725219316/peter-camenzind-autori-herman-hesse-duk-200000033-0.webp);\n  background-size: cover;\n  background-position: center;\n}\n\n.book-title {\n  font-size: 1.5rem;\n  font-weight: 900;\n  color: inherit;\n  line-height: 1.3;\n  text-transform: uppercase;\n}\n\n.book-cover-blue .book-title {\n  color: white;\n  font-size: 1.4rem;\n}\n\n.book-cover-pink .book-title-small {\n  color: white;\n  font-size: 1.3rem;\n  font-weight: 900;\n  line-height: 1.3;\n}\n\n@keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes fadeInRight {\n  from {\n    opacity: 0;\n    transform: translateX(50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Features Trust Section */\n.features-trust-section {\n  background: #f8f9fa;\n  padding: 40px 50px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.features-trust-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 30px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.trust-card {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  background: white;\n  padding: 20px;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n}\n\n.trust-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.trust-icon {\n  font-size: 2.5rem;\n  flex-shrink: 0;\n}\n\n.trust-content h4 {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0 0 5px 0;\n  font-family: \"Gilroy\", sans-serif;\n}\n\n.trust-content p {\n  font-size: 0.85rem;\n  color: #718096;\n  margin: 0;\n  font-family: \"Gilroy\", sans-serif;\n}\n\n/* Book Store Section */\n.book-store-section {\n  padding: 80px 50px;\n  background: white;\n}\n\n.store-layout {\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  gap: 40px;\n  align-items: start;\n}\n\n/* Sidebar Categories */\n.categories-sidebar {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px;\n  position: sticky;\n  top: 20px;\n  align-self: start;\n  max-height: calc(100vh - 40px);\n  overflow-y: auto;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.sidebar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.close-sidebar-btn {\n  display: none;\n  background: transparent;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #718096;\n  padding: 5px;\n  transition: all 0.3s ease;\n}\n\n.close-sidebar-btn:hover {\n  color: #2d3748;\n}\n\n.sidebar-overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n.sidebar-title {\n  font-size: 1.3rem;\n  font-weight: 800;\n  color: #2d3748;\n  margin: 0 0 20px 0;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #e2e8f0;\n  font-family: \"Gilroy\", sans-serif;\n}\n\n.category-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.category-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border: none;\n  background: white;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: \"Gilroy\", sans-serif;\n  font-size: 0.95rem;\n  color: #4a5568;\n  text-align: left;\n  width: 100%;\n}\n\n.category-item:hover {\n  background: #f7fafc;\n  color: #2d3748;\n}\n\n.category-item.active {\n  background: darkgray;\n  color: white;\n  font-weight: 700;\n}\n\n.category-icon {\n  font-size: 1.5rem;\n}\n\n.category-name {\n  flex: 1;\n}\n\n.category-arrow {\n  font-size: 1.2rem;\n  opacity: 0.5;\n}\n\n.category-item.active .category-arrow {\n  opacity: 1;\n}\n\n/* Book Store Section */\n.book-store-section {\n  padding: 80px 50px;\n  background: white;\n}\n\n.container {\n  max-width: 1400px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.store-title {\n  font-size: 3rem;\n  font-weight: 900;\n  font-family: \"Gilroy\", sans-serif;\n  text-align: center;\n  color: #2d3748;\n  margin: 0 0 15px 0;\n  letter-spacing: 2px;\n}\n\n.store-subtitle {\n  text-align: center;\n  color: #718096;\n  font-size: 1.1rem;\n  margin: 0 0 60px 0;\n  max-width: 700px;\n  margin-left: auto;\n  margin-right: auto;\n    font-family: \"Gilroy\", sans-serif;\n\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.section-title {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: #333;\n  margin: 0;\n}\n\n.view-all-link {\n  color: #666;\n  text-decoration: underline;\n  font-size: 0.95rem;\n  transition: color 0.3s ease;\n}\n\n.view-all-link:hover {\n  color: #333;\n}\n\n.products-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n  animation: fadeIn 0.6s ease;\n}\n\n/* Info Cards Section */\n.info-cards-section {\n  padding: 60px 50px;\n  background: white;\n}\n\n.info-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.info-card {\n  background: #2d3748;\n  border-radius: 8px;\n  overflow: hidden;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  min-height: 220px;\n  transition: all 0.3s ease;\n}\n\n.info-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.info-card-content {\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n}\n\n.info-card-title {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: white;\n  margin: 0;\n  line-height: 1.3;\n  text-transform: uppercase;\n}\n\n.info-card-subtitle {\n  font-size: 0.95rem;\n  color: white;\n  margin: 0;\n}\n\n.payment-logos {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.payment-logo {\n  background: white;\n  padding: 8px 12px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-align: center;\n  color: #333;\n  border: 1px solid #e0e0e0;\n}\n\n.info-card-image {\n  position: relative;\n  overflow: hidden;\n}\n\n.info-card-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.info-card:hover .info-card-image img {\n  transform: scale(1.05);\n}\n\n/* Promo Section */\n.promo-section {\n  padding: 60px 50px;\n  background: white;\n}\n\n.promo-cards {\n  display: grid;\n  grid-template-columns: 1.3fr 1fr;\n  gap: 20px;\n  margin-bottom: 50px;\n}\n\n.promo-card {\n  min-height: 450px;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.promo-image-card {\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.promo-image-card img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.promo-content-card {\n  background: #2d3748;\n  padding: 60px 50px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  color: white;\n}\n\n.promo-badge {\n  font-size: 0.85rem;\n  font-weight: 700;\n  letter-spacing: 2px;\n  margin-bottom: 20px;\n  opacity: 0.9;\n}\n\n.promo-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin: 0 0 20px 0;\n  line-height: 1.2;\n}\n\n.promo-description {\n  font-size: 1.1rem;\n  margin: 0 0 30px 0;\n  opacity: 0.95;\n}\n\n.promo-btn {\n  background: white;\n  color: #2d3748;\n  border: none;\n  padding: 16px 40px;\n  border-radius: 50px;\n  font-size: 1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  letter-spacing: 0.5px;\n}\n\n.promo-btn:hover {\n  background: #1a202c;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n}\n\n/* Features Row */\n.features-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 40px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.feature-item {\n  text-align: center;\n  padding: 20px;\n}\n\n.feature-icon {\n  font-size: 3rem;\n  margin-bottom: 15px;\n  color: #333;\n}\n\n.feature-title {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #333;\n  margin: 0 0 10px 0;\n}\n\n.feature-text {\n  font-size: 0.95rem;\n  color: #666;\n  margin: 0;\n  line-height: 1.5;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Footer */\n.footer {\n  background: #2d3748;\n  color: white;\n  padding: 40px 50px;\n  margin-top: 0;\n}\n\n.footer-content {\n  max-width: 1400px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.footer-content p {\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n.footer-links {\n  display: flex;\n  gap: 30px;\n}\n\n.footer-links a {\n  color: white;\n  text-decoration: none;\n  font-size: 0.9rem;\n  transition: color 0.3s ease;\n}\n\n.footer-links a:hover {\n  color: inherit;\n}\n\n/* Responsive Design */\n@media (max-width: 1400px) {\n  .products-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (max-width: 1024px) {\n  .hero-container {\n    padding: 0 30px;\n  }\n\n  .hero-content {\n    gap: 40px;\n  }\n\n  .hero-title {\n    font-size: 2.3rem;\n  }\n\n  .hero-book-1 {\n    width: 130px;\n    height: 180px;\n  }\n\n  .hero-book-2 {\n    width: 150px;\n    height: 210px;\n  }\n\n  .hero-book-3 {\n    width: 110px;\n    height: 160px;\n  }\n  \n  .book-store-section {\n    padding: 50px 30px;\n  }\n\n  .store-layout {\n    grid-template-columns: 1fr;\n    gap: 30px;\n  }\n\n  .categories-sidebar {\n    position: static;\n  }\n\n  .category-list {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n  }\n\n  .features-trust-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n  }\n  \n  .products-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 15px;\n  }\n\n  .info-cards-section {\n    padding: 50px 30px;\n  }\n\n  .info-cards-grid {\n    gap: 15px;\n  }\n\n  .promo-section {\n    padding: 50px 30px;\n  }\n\n  .promo-title {\n    font-size: 2rem;\n  }\n\n  .features-row {\n    gap: 30px;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero-slider-section {\n   /* padding: 20px 10px; */\n    padding: 75px 10px;\n    background-position: center center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    min-height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 10px;\n  }\n\n  .hero-container {\n    padding: 0;\n    width: 100%;\n  }\n\n  .hero-content {\n    grid-template-columns: 1fr;\n    gap: 20px;\n    min-height: auto;\n  }\n\n  .hero-text {\n    text-align: center;\n    display: none;\n  }\n\n  .hero-title {\n    font-size: 1.8rem;\n  }\n\n  .hero-description {\n    font-size: 0.95rem;\n  }\n\n  .hero-price {\n    font-size: 1.1rem;\n  }\n\n  .hero-images {\n    justify-content: flex-end;\n    padding: 10px 10px 10px 0;\n    gap: 4px;\n    margin-right: -10px;\n  }\n\n  .hero-book-1 {\n    width: 55px;\n    height: 75px;\n  }\n\n  .hero-book-2 {\n    width: 70px;\n    height: 95px;\n    margin-bottom: 5px;\n  }\n\n  .hero-book-3 {\n    width: 50px;\n    height: 70px;\n  }\n\n\n  \n  .hero-books {\n    justify-content: center;\n    gap: 15px;\n  }\n  \n  .book-1,\n  .book-2,\n  .book-3 {\n    width: 100px;\n    height: 140px;\n  }\n  \n  .book-2 {\n    width: 110px;\n    height: 155px;\n  }\n  \n  .book-title,\n  .book-cover-blue .book-title,\n  .book-title-small {\n    font-size: 0.8rem;\n  }\n\n  .book-store-section {\n    padding: 40px 20px;\n  }\n\n  .store-layout {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  /* Show mobile categories bar */\n  .mobile-categories-bar {\n    display: block;\n  }\n\n  /* Hide sidebar completely on mobile */\n  .categories-sidebar {\n    display: none;\n  }\n\n  /* Hide sidebar overlay on mobile */\n  .sidebar-overlay {\n    display: none;\n  }\n\n  .features-trust-section {\n    padding: 30px 20px;\n  }\n\n  .features-trust-grid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .trust-card {\n    padding: 15px;\n  }\n\n  .store-title {\n    font-size: 2rem;\n  }\n\n  .store-subtitle {\n    font-size: 1rem;\n    margin-bottom: 40px;\n  }\n\n  .section-title {\n    font-size: 1.5rem;\n  }\n\n  .products-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n\n  .info-cards-section {\n    padding: 40px 20px;\n  }\n\n  .info-cards-grid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .info-card {\n    grid-template-columns: 1fr;\n    min-height: auto;\n  }\n\n  .info-card-image {\n    height: 180px;\n  }\n\n  .promo-section {\n    padding: 40px 20px;\n  }\n\n  .promo-cards {\n    grid-template-columns: 1fr;\n    margin-bottom: 40px;\n  }\n\n  .promo-card {\n    min-height: 300px;\n  }\n\n  .promo-content-card {\n    padding: 40px 25px;\n  }\n\n  .promo-title {\n    font-size: 1.8rem;\n  }\n\n  .promo-description {\n    font-size: 1rem;\n  }\n\n  .features-row {\n    grid-template-columns: 1fr;\n    gap: 30px;\n  }\n\n  .feature-icon {\n    font-size: 2.5rem;\n  }\n  \n  .footer {\n    padding: 30px 20px;\n  }\n  \n  .footer-content {\n    flex-direction: column;\n    gap: 20px;\n    text-align: center;\n  }\n  \n  .footer-links {\n    gap: 20px;\n  }\n}\n\n/* ==========================================================================\n   Figma design port - Hero, category banners, steps, curated product rows\n   ========================================================================== */\n\n/* Hero — Pixory-style washed flat-lay: Fletaime's own covers scattered\n   behind a white wash, centered white copy + white pill CTA on top. */\n.pixory-hero {\n  position: relative;\n  margin: 16px 24px 0;\n  border-radius: 18px;\n  min-height: 520px;\n  background: #f6f3ef;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pixory-hero-photo {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* White wash over the collage, below the content */\n.pixory-hero::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.55);\n}\n\n.pixory-hero-content {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 18px;\n  padding: 72px 24px;\n}\n\n.pixory-hero-title {\n  font-size: clamp(34px, 4.5vw, 54px);\n  font-weight: 700;\n  color: white;\n  line-height: 1.15;\n  margin: 0;\n  text-transform: lowercase;\n  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.22);\n}\n\n.pixory-hero-subtitle {\n  color: white;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n  max-width: 480px;\n  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.35), 0 2px 16px rgba(0, 0, 0, 0.25);\n}\n\n.pixory-hero-btn {\n  border: none;\n  background: white;\n  color: #5a5a5a;\n  padding: 15px 44px;\n  border-radius: 999px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.pixory-hero-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);\n}\n\n/* Category banners */\n.figma-banners {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.figma-banners-left {\n  flex: 1 1 400px;\n  display: flex;\n  flex-direction: column;\n}\n\n.figma-banner-wide {\n  background: white;\n  height: 328px;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n}\n\n.figma-banner-wide-img-wrap {\n  flex: 0 0 40%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.figma-banner-wide-img-wrap img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.figma-banner-wide-text {\n  flex: 1 1 0;\n  min-width: 0;\n  text-align: right;\n  padding: 0 48px;\n}\n\n.figma-banner-wide-title {\n  font-size: 40px;\n  color: #000;\n  margin: 0 0 12px;\n  font-weight: 800;\n  letter-spacing: 1px;\n}\n\n.figma-banner-wide-desc {\n  font-size: 14px;\n  color: #909090;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.figma-banners-squares {\n  display: flex;\n  height: 272px;\n}\n\n.figma-banner-square {\n  flex: 1 0 0;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n}\n\n.figma-banner-square.light { background: var(--pixory-cream); }\n.figma-banner-square.dark { background: var(--pixory-ink); }\n\n.figma-banner-square-img-wrap {\n  flex: 0 0 42%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.figma-banner-square-img-wrap img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.figma-banner-square-img-wrap img.mirrored {\n  transform: scaleX(-1);\n}\n\n.figma-banner-square-text {\n  flex: 1 1 0;\n  min-width: 0;\n  text-align: right;\n  padding: 0 20px;\n}\n\n.figma-banner-square-title {\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  line-height: 1.3;\n  margin: 0 0 8px;\n  color: #000;\n}\n\n.figma-banner-square-title span {\n  font-weight: 800;\n  color: var(--pixory-pink-deep);\n}\n\n.figma-banner-square.dark .figma-banner-square-title {\n  color: #fff;\n}\n\n.figma-banner-square-desc {\n  font-size: 13px;\n  color: #909090;\n  margin: 0;\n}\n\n.figma-banner-big {\n  flex: 1 1 300px;\n  height: 600px;\n  background: #e2e2e2;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.figma-banner-big-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* Cilësia e produktit */\n.figma-features {\n  display: flex;\n  gap: 24px;\n  padding: 56px 80px;\n  background: white;\n  flex-wrap: wrap;\n}\n\n/* Pixory-style feature card: gray head (title + desc) over a large photo */\n.figma-feature-card {\n  flex: 1 1 280px;\n  display: flex;\n  flex-direction: column;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.figma-feature-head {\n  background: #f5f5f5;\n  padding: 20px 24px 24px;\n  min-height: 130px;\n}\n\n.figma-feature-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #b3b3b3;\n  text-transform: lowercase;\n  margin: 0 0 10px;\n}\n\n.figma-feature-desc {\n  font-size: 14px;\n  color: #3a3a3a;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.figma-feature-photo {\n  aspect-ratio: 1 / 1;\n  overflow: hidden;\n}\n\n.figma-feature-photo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* Njihu me markën — foto majtas, titull + accordion djathtas */\n.figma-brand-section {\n  display: flex;\n  margin: 0 80px 56px;\n  border-radius: 12px;\n  overflow: hidden;\n  min-height: 560px;\n}\n\n.figma-brand-photo {\n  flex: 1 1 50%;\n  min-width: 0;\n}\n\n.figma-brand-photo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.figma-brand-content {\n  flex: 1 1 50%;\n  background: #f5f5f5;\n  padding: 40px 48px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 24px;\n}\n\n.figma-brand-title {\n  font-size: 30px;\n  font-weight: 700;\n  color: #c4c4c4;\n  text-transform: lowercase;\n  margin: 0 0 6px;\n}\n\n.figma-brand-sub {\n  font-size: 15px;\n  color: #3a3a3a;\n  margin: 0;\n}\n\n.figma-brand-item {\n  border-top: 1px solid #e8e8e8;\n}\n\n.figma-brand-item:first-child {\n  border-top: none;\n}\n\n.figma-brand-item-head {\n  width: 100%;\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 0;\n  font-family: inherit;\n  font-size: 20px;\n  font-weight: 700;\n  color: #2d2d2d;\n  text-transform: lowercase;\n  text-align: left;\n}\n\n.figma-brand-chevron {\n  width: 18px;\n  height: 18px;\n  color: #b3b3b3;\n  flex-shrink: 0;\n  transition: transform 0.2s ease;\n}\n\n.figma-brand-chevron.open {\n  transform: rotate(180deg);\n}\n\n.figma-brand-item-text {\n  font-size: 15px;\n  color: #3a3a3a;\n  line-height: 1.5;\n  margin: 0 0 16px;\n  max-width: 440px;\n}\n\n/* Si funksionon steps */\n.figma-steps {\n  background: #fafafa;\n  padding: 56px 80px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.figma-steps-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.figma-steps-title {\n  font-size: 24px;\n  font-weight: 500;\n  color: #2e2e2e;\n  margin: 0;\n}\n\n.figma-steps-arrows {\n  display: flex;\n  gap: 16px;\n}\n\n.figma-steps-arrow {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n}\n\n.figma-steps-arrow img {\n  width: 32px;\n  height: 32px;\n}\n\n.figma-steps-arrow.rotated img {\n  transform: rotate(180deg);\n}\n\n.figma-steps-row {\n  display: flex;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n\n.figma-step-card {\n  background: #e2e2e2;\n  border-radius: 15px;\n  flex: 1 1 140px;\n  min-width: 135px;\n  height: 128px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px;\n}\n\n.figma-step-icon {\n  width: 40px;\n  height: 40px;\n  color: #2e2e2e;\n}\n\n.figma-step-label {\n  font-size: 16px;\n  font-weight: 500;\n  color: #2e2e2e;\n  text-align: center;\n  margin: 0;\n}\n\n/* Curated product sections — Pixory-style white row cards on light gray */\n.figma-products-section,\n.figma-discounts-section {\n  padding: 32px 40px 40px;\n  background: #f4f4f4;\n}\n\n.figma-category-row {\n  background: white;\n  border: 1px solid #ececec;\n  border-radius: 14px;\n  padding: 20px 20px 24px;\n  margin-bottom: 20px;\n}\n\n.figma-category-row:last-child {\n  margin-bottom: 0;\n}\n\n/* Loading placeholder for the category rows — occupies roughly the same\n   space as the real content so nothing below (e.g. \"njihu me markën\")\n   jumps around once products finish loading in. */\n.skeleton-block {\n  background: linear-gradient(90deg, #eee 25%, #f5f5f5 37%, #eee 63%);\n  background-size: 400% 100%;\n  animation: skeleton-pulse 1.4s ease infinite;\n  border-radius: 8px;\n}\n\n.skeleton-row-title {\n  width: 140px;\n  height: 20px;\n}\n\n.skeleton-card {\n  aspect-ratio: 3 / 4;\n  border-radius: 10px;\n}\n\n@keyframes skeleton-pulse {\n  0% { background-position: 100% 50%; }\n  100% { background-position: 0 50%; }\n}\n\n.figma-category-row-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.figma-category-row-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #a9a9a9;\n  text-transform: lowercase;\n  margin: 0;\n}\n\n.pixory-row-arrows {\n  display: flex;\n  gap: 10px;\n}\n\n.pixory-row-arrows button {\n  background: none;\n  border: 1px solid #e5e5e5;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  transition: border-color 0.15s ease;\n}\n\n.pixory-row-arrows button:hover {\n  border-color: #bdbdbd;\n}\n\n.pixory-row-arrows img {\n  width: 16px;\n  height: 16px;\n  opacity: 0.6;\n}\n\n.pixory-row-arrows .rotated img {\n  transform: rotate(180deg);\n}\n\n.figma-row-see-all {\n  display: block;\n  width: fit-content;\n  margin: 20px auto 0;\n  font-size: 15px;\n  font-weight: 500;\n  color: #2e2e2e;\n  text-decoration: none;\n  border-bottom: 1px solid transparent;\n  transition: border-color 0.15s ease;\n}\n\n.figma-row-see-all:hover {\n  border-bottom-color: #2e2e2e;\n}\n\n/* Pixory-style product card — Home.js only (PixoryHomeProductCard), not used\n   by the Photobooks catalog, which keeps FigmaProductCard/.figma-product-card.\n   Structure: gray lowercase series label + \"e re\" pill header, large centered\n   cover, name/price row, dark pill CTA. */\n/* 3 large cards visible per row; the rest scroll horizontally (snap + arrows) */\n.pixory-card-grid {\n  display: grid;\n  grid-auto-flow: column;\n  grid-auto-columns: calc((100% - 40px) / 3);\n  gap: 20px;\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  scrollbar-width: none;\n  padding-bottom: 4px;\n}\n\n.pixory-card-grid::-webkit-scrollbar {\n  display: none;\n}\n\n.pixory-card {\n  background: white;\n  border: 1px solid #ececec;\n  border-radius: 16px;\n  padding: 24px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  scroll-snap-align: start;\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.pixory-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 14px 26px rgba(0, 0, 0, 0.08);\n}\n\n.pixory-card-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.pixory-card-label {\n  flex: 1;\n  font-size: 22px;\n  font-weight: 700;\n  color: #c4c4c4;\n  margin: 0;\n  text-transform: lowercase;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pixory-card-tag {\n  background: #f8dee4;\n  color: #3a3a3a;\n  font-size: 11px;\n  font-weight: 700;\n  padding: 4px 10px;\n  border-radius: 999px;\n  flex-shrink: 0;\n}\n\n.pixory-card-like {\n  background: white;\n  border: 1px solid #eee;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.pixory-card-like.active {\n  background: var(--pixory-pink-deep);\n  border-color: var(--pixory-pink-deep);\n}\n\n.pixory-card-like.active img { filter: brightness(0) invert(1); }\n.pixory-card-like img { width: 14px; height: 14px; }\n\n/* No drop-shadow here: the mockup images carry white padding, so a shadow\n   around the image rectangle reads as a white slab instead of a book. On the\n   white card the padding blends away and the book \"floats\" like Pixory's. */\n.pixory-card-image {\n  position: relative;\n  height: 400px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.pixory-card-cover {\n  max-width: 88%;\n  max-height: 100%;\n  object-fit: contain;\n  transition: opacity 0.25s ease;\n}\n\n/* Second product photo, revealed on hover (only on cards that have one) */\n.pixory-card-cover-alt {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: 0;\n}\n\n.pixory-card:hover .has-alt .pixory-card-cover-alt {\n  opacity: 1;\n}\n\n.pixory-card:hover .has-alt .pixory-card-cover:not(.pixory-card-cover-alt) {\n  opacity: 0;\n}\n\n.pixory-card-info {\n  margin-top: auto;\n}\n\n.pixory-card-meta {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 4px 8px;\n  margin-bottom: 10px;\n}\n\n.pixory-card-name {\n  font-size: 21px;\n  font-weight: 700;\n  color: #b9b9b9;\n  text-transform: lowercase;\n  margin: 0;\n}\n\n.pixory-card-price {\n  font-size: 22px;\n  font-weight: 700;\n  color: #2e2e2e;\n  margin: 0;\n  white-space: nowrap;\n}\n\n.pixory-card-desc {\n  font-size: 15px;\n  color: #3a3a3a;\n  line-height: 1.4;\n  margin: 6px 0 0;\n}\n\n.pixory-card-btn {\n  align-self: flex-start;\n  background: #3a3a3a;\n  color: white;\n  border: none;\n  border-radius: 999px;\n  padding: 14px 38px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  margin-top: 16px;\n  transition: background 0.2s ease;\n}\n\n.pixory-card-btn:hover {\n  background: #222;\n}\n\n.figma-discounts-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #a9a9a9;\n  text-transform: lowercase;\n  margin: 0 0 16px;\n}\n\n.figma-products-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.figma-product-card {\n  background: #e2e2e2;\n  border-radius: 9px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  border: 1px solid grey;\n}\n\n.figma-like-btn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 1;\n  background: white;\n  border: none;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);\n}\n\n.figma-like-btn.active {\n  background: #ca247b;\n}\n\n.figma-like-btn.active .figma-like-icon {\n  filter: brightness(0) invert(1);\n}\n\n.figma-like-icon {\n  width: 18px;\n  height: 18px;\n}\n\n.figma-product-image {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.figma-product-image img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.figma-product-info {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  text-align: center;\n  padding: 20px 16px 24px;\n  box-sizing: border-box;\n}\n\n.figma-product-name {\n  font-size: 16px;\n  font-weight: 500;\n  color: #000;\n  margin: 0;\n}\n\n.figma-product-price {\n  font-size: 24px;\n  font-weight: 600;\n  color: #000;\n  margin: 0;\n}\n\n.figma-product-discount {\n  color: #b3251e;\n  font-size: 14px;\n}\n\n.figma-product-btn {\n  background: #2e2e2e;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 32px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n/* 4-up banner strip */\n.figma-strip {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.figma-strip-item {\n  flex: 1 1 260px;\n  min-height: 320px;\n  display: flex;\n  align-items: flex-end;\n  padding: 32px;\n  cursor: pointer;\n}\n\n.figma-strip-item.white { background: white; }\n.figma-strip-item.gray { background: #e2e2e2; }\n.figma-strip-item.dark { background: #2e2e2e; }\n\n.figma-strip-title {\n  font-size: 28px;\n  font-weight: 300;\n  color: #000;\n  margin: 0 0 12px;\n}\n\n.figma-strip-title.dark { color: white; }\n\n.figma-strip-desc {\n  font-size: 14px;\n  color: #909090;\n  margin: 0 0 16px;\n  max-width: 260px;\n}\n\n.figma-strip-desc.dark { color: #cfcfcf; }\n\n.figma-strip-btn {\n  border: 1px solid #2e2e2e;\n  background: transparent;\n  color: #2e2e2e;\n  padding: 12px 32px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.figma-strip-btn.dark {\n  border-color: white;\n  color: white;\n}\n\n/* Testimonials and customer-photo gallery — styled ahead of time, rendered\n   only once SHOW_TESTIMONIALS / SHOW_CUSTOMER_GALLERY are flipped on in\n   Home.js with real content. */\n.figma-testimonials-section,\n.figma-gallery-section {\n  padding: 56px 80px;\n  background: #fafafa;\n}\n\n.figma-testimonials-title {\n  font-size: 24px;\n  font-weight: 500;\n  color: #000;\n  margin: 0 0 24px;\n}\n\n.figma-gallery-title {\n  font-size: 30px;\n  font-weight: 700;\n  color: #c4c4c4;\n  text-transform: lowercase;\n  text-align: center;\n  margin: 0 0 6px;\n}\n\n.figma-testimonials-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n}\n\n.figma-testimonial-card {\n  background: white;\n  border: 1px solid #ece5e8;\n  border-radius: 16px;\n  padding: 24px;\n}\n\n.figma-testimonial-quote {\n  font-size: 15px;\n  color: #2e2e2e;\n  line-height: 1.5;\n  margin: 0 0 12px;\n}\n\n.figma-testimonial-author {\n  font-size: 14px;\n  font-weight: 600;\n  color: #6b6b6b;\n  margin: 0;\n}\n\n.figma-gallery-sub {\n  font-size: 15px;\n  color: #3a3a3a;\n  text-align: center;\n  margin: 0 0 32px;\n}\n\n.figma-gallery-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n}\n\n.figma-gallery-item {\n  aspect-ratio: 3 / 4;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.figma-gallery-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.figma-gallery-social-btn {\n  display: inline-block;\n  margin-top: 24px;\n  background: #d9d9d9;\n  color: white;\n  font-size: 15px;\n  font-weight: 700;\n  text-transform: lowercase;\n  text-decoration: none;\n  padding: 14px 32px;\n  border-radius: 999px;\n  transition: background 0.2s ease;\n}\n\n.figma-gallery-social-btn:hover {\n  background: #c4c4c4;\n}\n\n/* Nevojë për ndihmë */\n.figma-help-section {\n  padding: 64px 80px;\n  background: var(--pixory-cream);\n  text-align: center;\n}\n\n.figma-help-title {\n  font-size: 26px;\n  font-weight: 700;\n  color: var(--pixory-ink);\n  margin: 0 0 8px;\n}\n\n.figma-help-desc {\n  font-size: 15px;\n  color: var(--pixory-muted);\n  margin: 0 0 24px;\n}\n\n.figma-help-actions {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.figma-help-btn {\n  display: inline-block;\n  padding: 14px 32px;\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 600;\n  text-decoration: none;\n  background: var(--pixory-ink);\n  color: white;\n  transition: transform 0.2s ease;\n}\n\n.figma-help-btn.outline {\n  background: transparent;\n  color: var(--pixory-ink);\n  border: 1px solid var(--pixory-ink);\n}\n\n.figma-help-btn:hover {\n  transform: translateY(-2px);\n}\n\n/* Phone only - iPad's 768px width and up keeps the banners. Placed after\n   the base .figma-banners rule (line ~1599) since an earlier media query\n   with equal specificity loses the cascade to a later unconditional rule. */\n@media (max-width: 767px) {\n  .figma-banners {\n    display: none;\n  }\n}\n\n@media (max-width: 900px) {\n  .pixory-hero {\n    margin: 12px 16px 0;\n    border-radius: 14px;\n    min-height: 420px;\n  }\n\n  .figma-steps,\n  .figma-features,\n  .figma-products-section,\n  .figma-discounts-section,\n  .figma-testimonials-section,\n  .figma-gallery-section,\n  .figma-help-section {\n    padding: 32px 24px;\n  }\n\n  .figma-banner-wide {\n    height: auto;\n    flex-direction: column;\n  }\n\n  .figma-banner-wide-img-wrap {\n    flex: 0 0 auto;\n    width: 100%;\n    height: 220px;\n  }\n\n  .figma-banner-wide-text {\n    text-align: left;\n    padding: 16px;\n  }\n\n  .figma-banners-squares {\n    flex-direction: column;\n    height: auto;\n  }\n\n  .figma-banner-square {\n    flex-direction: column;\n    height: auto;\n  }\n\n  .figma-banner-square-img-wrap {\n    flex: 0 0 auto;\n    width: 100%;\n    height: 160px;\n  }\n\n  .figma-banner-square-text {\n    text-align: left;\n    padding: 16px;\n    width: 100%;\n  }\n\n  .figma-banner-big {\n    height: 320px;\n  }\n\n  .figma-products-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n\n  .pixory-card-grid {\n    grid-auto-columns: 78%;\n    gap: 14px;\n  }\n\n  .pixory-card {\n    padding: 16px;\n  }\n\n  .pixory-card-image {\n    height: 260px;\n  }\n\n  .pixory-card-label {\n    font-size: 17px;\n  }\n\n  .pixory-card-name {\n    font-size: 17px;\n  }\n\n  .pixory-card-price {\n    font-size: 18px;\n  }\n\n  .pixory-card-desc {\n    font-size: 14px;\n  }\n\n  .pixory-card-btn {\n    padding: 12px 30px;\n    font-size: 14px;\n  }\n\n  .figma-brand-section {\n    flex-direction: column;\n    margin: 0 16px 32px;\n    min-height: 0;\n  }\n\n  .figma-brand-photo {\n    flex: none;\n    height: 260px;\n  }\n\n  .figma-brand-content {\n    padding: 24px;\n    gap: 28px;\n  }\n\n  .figma-brand-title {\n    font-size: 24px;\n  }\n\n  .figma-brand-item-head {\n    font-size: 17px;\n  }\n\n  .figma-gallery-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n  }\n\n  .figma-gallery-title {\n    font-size: 24px;\n  }\n\n  .figma-product-info {\n    padding: 12px 10px 16px;\n    gap: 10px;\n  }\n\n  .figma-product-name {\n    font-size: 14px;\n  }\n\n  .figma-product-price {\n    font-size: 18px;\n  }\n\n  .figma-product-btn {\n    padding: 10px 16px;\n    font-size: 13px;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
